import Popover from 'bootstrap/js/dist/popover';

document.addEventListener("turbo:load", function() {    
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl)
  })
});
